/* eslint-disable @typescript-eslint/no-explicit-any */
import requestAuth from 'utils/requestAuth';

const userService = {
  getList: (params: any) => requestAuth.get('/user', { params }),
  getById: (id: string) => requestAuth.get(`/user/${id}`),
  getUserPermision: (params: any) =>
    requestAuth.get(`/user-permission`, { params }),

  create: (data: any) => requestAuth.post('/user', data),
  update: (data: any) => requestAuth.put(`/user-permission`, data),
  updatePos: (id: any, data: any) =>
    requestAuth.put(`/user-permission/menu/pos/${id}`, data)
};

export default userService;
